(function() {
  const initSizeValidation = () => {
    // 1. Unselect the size option on page load
    const sizeFieldsets = document.querySelectorAll('.variant-picker__option[data-is-size="true"]');
    
    sizeFieldsets.forEach(fieldset => {
      const radios = fieldset.querySelectorAll('input[type="radio"]');
      radios.forEach(radio => radio.checked = false);

      const visualSelected = fieldset.querySelectorAll('.is-selected');
      visualSelected.forEach(el => el.classList.remove('is-selected'));
    });

    // 2. Intercept clicks on ALL wrappers inside the product block
    const productInfos = document.querySelectorAll('.product-info, safe-sticky');
    
    productInfos.forEach(info => {
      // Find the size radios in this specific product block
      const sizeRadios = Array.from(info.querySelectorAll('input[type="radio"]'))
        .filter(radio => radio.closest('.variant-picker__option[data-is-size="true"]'));
      
      if (sizeRadios.length === 0) return;

      const wrappers = info.querySelectorAll('.js-atc-wrapper');
      if (wrappers.length === 0) return;

      let isSizeSelected = false;

      // Listen for size selection
      sizeRadios.forEach(radio => {
        radio.addEventListener('change', () => {
          if (radio.checked) {
            isSizeSelected = true;
            
            // Remove is-selected from all options in this group
            const fieldset = radio.closest('.variant-picker__option');
            if (fieldset) {
              const allVisuals = fieldset.querySelectorAll('.block-swatch, .color-swatch, .thumbnail-swatch, .block-underline');
              allVisuals.forEach(v => v.classList.remove('is-selected'));

              // Add is-selected to the clicked one
              const clickedLabel = fieldset.querySelector(`[for="${radio.id}"]`);
              if (clickedLabel) {
                clickedLabel.classList.add('is-selected');
              }
            }
            
            wrappers.forEach(wrapper => {
              // Unblock all buttons in this wrapper
              const btns = wrapper.querySelectorAll('button');
              btns.forEach(btn => btn.classList.remove('is-size-blocked'));
              
              wrapper.classList.remove('shake-animation');
              
              const tooltip = wrapper.querySelector('.size-validation-tooltip');
              if (tooltip) tooltip.classList.remove('is-active');
            });
          }
        });
      });

      // Physically block the buttons initially and setup wrappers
      wrappers.forEach(wrapper => {
        const btns = wrapper.querySelectorAll('button');
        btns.forEach(btn => btn.classList.add('is-size-blocked'));
        
        const tooltip = wrapper.querySelector('.size-validation-tooltip');

        // Wrapper catches the click because buttons have pointer-events: none
        wrapper.addEventListener('click', (e) => {
          if (!isSizeSelected) {
            e.preventDefault();
            e.stopPropagation();

            // Shake animation on the wrapper
            wrapper.classList.remove('shake-animation');
            void wrapper.offsetWidth;
            wrapper.classList.add('shake-animation');

            // Show Tooltip
            if (tooltip) {
              document.body.appendChild(tooltip);
              tooltip.classList.add('is-active');
              setTimeout(() => tooltip.classList.remove('is-active'), 3000);
            }
          }
        });
      });
      
      // As a fallback catch-all, also prevent form submit just in case (e.g. Enter key)
      const form = info.querySelector('form[action*="/cart/add"]');
      if (form) {
        form.addEventListener('submit', (e) => {
          if (!isSizeSelected) {
            e.preventDefault();
            e.stopImmediatePropagation();
          }
        }, true);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeValidation);
  } else {
    initSizeValidation();
  }
})();
